import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Paper from '@material-ui/core/Paper';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { Alert, AlertTitle } from '@material-ui/lab';
import React, { useEffect, useState } from 'react';
import basePCUrl from '../../../Globals';
import usePortalAuth from '../../../auth/usePortalAuth';
import PasswordChecklist from 'react-password-checklist';

import './NewUser.css';
import RegisterWhatCapturedInterestDropdown from './RegisterWhatCapturedInterestDropdown';
import NewUserLoadingModal from './NewUserLoadingModal';
import TermsAndConditionsModal from './TermsAndConditionsModal';
import NewUserNavBar from './NewUserNavBar';


const NewUser = (props) => {
  const [loadingNewRegister, setLoadingNewRegister] = useState(false);
  const [purchaseProduct, setPurchaseProduct] = useState(false);
  const [showPasswordChecklist, setShowPasswordChecklist] = useState(false);
  const { loading, getAccessTokenSilently } = usePortalAuth();

  const [errorEmailText, setErrorEmailText] = useState();
  const [errorEmail, setErrorEmail] = useState(false);
  const [errorEmailConflict, setErrorEmailConflict] = useState(false);

  const [errorPasswordText, setErrorPasswordText] = useState();
  const [errorPasswordList, setErrorPasswordList] = useState([]);
  const [errorPassword, setErrorPassword] = useState();

  const [termsAndConditionsModal, setTermsAndConditionsModal] = useState(false);

  const [errorMessage, setErrorMessage] = useState();
  const [successMessage, setSuccessMessage] = useState(false);

  const [formState, setFormState] = React.useState({
    email: '',
    password: '',
    passwordAgain: '',
    name: '',
    companyName: '',
    interest: '', // Added for RegisterWhatCapturedInterestDropdown
    checkedB: false, // Ensure checkbox state is tracked
  });

  const {
    email,
    name,
    password,
    passwordAgain,
    companyName,
    interest,
    checkedB,
  } = formState;

  const handleChange = (event) => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    setFormState({ ...formState, [event.target.name]: value });
    if (event.target.name === 'password' && event.target.value.length > 0) {
      setShowPasswordChecklist(true);
    } else if (event.target.name === 'password' && event.target.value.length === 0) {
      setShowPasswordChecklist(false);
    }
  };

  var emailCheck =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const handleEmailChange = (event) => {
    if (event.target.name === 'email' && event.target.value.match(emailCheck)) {
      setFormState({
        ...formState,
        [event.target.name]: event.target.value.toLowerCase(),
      });
      setErrorEmailText('');
      setErrorEmail(false);
    } else if (
      event.target.name === 'email' &&
      event.target.value.length > 0 &&
      !event.target.value.match(emailCheck)
    ) {
      setErrorEmailText('Invalid Email');
      setErrorEmail(true);
    } else if (event.target.name === 'email' && event.target.value.length === 0) {
      setErrorEmail(false);
    }
  };

  const ErrorMessageAlert = () => {
    const classes = useStyles();
    if (errorMessage != undefined && errorMessage.includes('9873-009')) {
      return (
        <div className={classes.root}>
          <Alert severity="error" onClose={() => setErrorMessage(null)}>
          <AlertTitle>Error</AlertTitle>
            This email has already been used to created a PhishCloud account.
            <br/>
            <strong><a href="https://portal.phishcloud.io">Sign in to the portal here</a></strong>
          </Alert>
        </div>
      );
    } else if (errorMessage != undefined) {
      // return (
      //   <div className={classes.root}>
      //     <Alert severity="error" onClose={() => setErrorMessage(null)}>
      //       {errorMessage}
      //     </Alert>
      //   </div>
      // );
      pushToRegisterErrorPage();
    } else if (errorMessage === undefined || errorMessage === null) {
      return null;
    }
  };

  const pushToSuccessPage = () => {
    props.history.push('/Register/Verify?pad=&signUpEmail=' + email);
  };

  const pushToRegisterErrorPage = () => {
    props.history.push('/Register/Error');
  };

  const createAccount = async () => {
    setLoadingNewRegister(true);
    const finalEmail = email.toLowerCase();

  
      var data = {
        email: finalEmail,
        name: name,
        description: companyName,
        password: password,
        interest: interest
      };
    

    fetch(basePCUrl, {
      credentials: 'same-origin',
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        Action: 'createAccount',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          console.log('Looks like there was a problem. Status Code: ' + response.status);
          pushToRegisterErrorPage();
          return;
        }

        response.json().then((data) => {
          if (data.error != undefined) {
            setErrorMessage(data.error);
            setLoadingNewRegister(false);
          } else {
            setLoadingNewRegister(false);
            setSuccessMessage(true)
            //pushToSuccessPage();
          }
        });
      })
      .catch(function (err) {
        console.log('Fetch Error :-S', err);
      });
  };

  const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
      '& > * + *': {
        marginTop: theme.spacing(2),
      },
    },
  }));

  const classes = useStyles();

  const EmailConflictAlert = () => {
    const classes = useStyles();
    if (errorEmailConflict === true) {
      return (
        <div className={classes.root}>
          <Alert severity="error" onClose={() => setErrorEmailConflict(false)}>
            That email is already registered with PhishCloud.
          </Alert>
        </div>
      );
    } else if (errorEmailConflict === false) {
      return null;
    }
  };


  const formSubmission = (event) => {
    event.preventDefault();
    if (
      name != '' &&
      name != undefined &&
      email != '' &&
      email != undefined &&
      password != '' &&
      password != undefined &&
      passwordAgain != '' &&
      passwordAgain != undefined &&
      password === passwordAgain &&
      errorEmail === false &&
      companyName != '' &&
      companyName != undefined &&
      interest != '' &&
      interest != undefined &&
      checkedB === true
    ) {
      createAccount();
    }
  };

    const handleCloseTab = () => {
      console.log("I should be closing!")
      window.open('about:blank', '_self');
      window.close();
    };
  

  return (
    <React.Fragment>
      {!loading && !successMessage ? (
        <React.Fragment>
          <div id="signUpParent">
            <div id="payment-form">
            

              <form id="createUserForm" onSubmit={formSubmission}>
                <section>
                  {purchaseProduct === false ? (
                    <Paper elevation={3} id="signUpFieldset">
                      <label>
                        <div id="textfieldTitle">Name</div>
                        <TextField
                          name="name"
                          class="field"
                          onChange={handleChange}
                          className="newUserInput"
                          InputProps={{ disableUnderline: true }}
                          required
                        />
                      </label>

                      <label>
                        <span id="textfieldTitle">Company Name</span>
                        <TextField
                          name="companyName"
                          class="field"
                          onChange={handleChange}
                          className="newUserInput"
                          InputProps={{ disableUnderline: true }}
                          required
                        />
                      </label>

                      <label>
                        {errorEmail === false ? (
                          <div id="textfieldTitle">Email</div>
                        ) : (
                          <div id="textfieldTitle" style={{ color: 'red' }}>
                            Invalid Email
                          </div>
                        )}
                        <TextField
                          required
                          name="email"
                          onChange={handleEmailChange}
                          type="email"
                          class="field"
                          className="newUserInput"
                          InputProps={{ disableUnderline: true }}
                        />
                      </label>
                      <ErrorMessageAlert />
                      <label>
                        <span id="textfieldTitle">Password</span>
                        <TextField
                          name="password"
                          id="password"
                          class="field"
                          type="password"
                          className="newUserInput"
                          onChange={handleChange}
                          InputProps={{ disableUnderline: true }}
                          required
                        />
                      </label>

                      <label>
                        <span id="textfieldTitle">Confirm Password</span>
                        <TextField
                          name="passwordAgain"
                          class="field"
                          type="password"
                          className="newUserInput"
                          onChange={handleChange}
                          InputProps={{ disableUnderline: true }}
                          required
                        />
                      </label>
                      {showPasswordChecklist && (
                        <PasswordChecklist
                          rules={['minLength', 'specialChar', 'number', 'capital', 'match']}
                          minLength={5}
                          value={password}
                          valueAgain={passwordAgain}
                          onChange={(isValid) => {}}
                          style={{ marginBottom: '10px'}}
                        />
                      )}
                      <label>
                        <span style={{width: 'auto'}} id="textfieldTitle">What Captured Your Interest in PhishCloud?</span>

          <Select
            className="newUserInput"
            name="interest"
            value={formState.interest}
            onChange={handleChange}
            displayEmpty
            required
          >
            <MenuItem value="">
              <em>Please select an option</em>
            </MenuItem>
            <MenuItem value={"Browser Security"}>Browser Security</MenuItem>
            <MenuItem value={"Awareness Training"}>Awareness Training</MenuItem>
            <MenuItem value={"Both"}>Both</MenuItem>
          </Select>

                      </label>
                    </Paper>
                  ) : null}
                   <FormControlLabel
                    control={
                      <Checkbox
                        checked={checkedB}
                        onChange={handleChange}
                        name="checkedB"
                        color="primary"
                        required
                      />
                    }
                    label={
                      <span>
                        I accept the{' '}
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            setTermsAndConditionsModal(true);
                          }}
                          style={{ color: 'blue', textDecoration: 'underline' }}
                        >
                          TERMS AND CONDITIONS
                        </a>
                      </span>
                    }
                  />
                  <TermsAndConditionsModal isOpen={termsAndConditionsModal} toggleTandC={setTermsAndConditionsModal}/>
                  <NewUserLoadingModal isOpen={loadingNewRegister} />
                    <button
                      id="stripeButton"
                      type="submit"
                    >
                      {' '}
                      REGISTER
                    </button>
                </section>

                <br />
                
                <p id="alreadySignedUp">
                  Already signed up? Sign in to the portal here:{' '}
                  <a href="https://portal.phishcloud.io/">portal.phishcloud.io/</a>{' '}
                </p>
              </form>
            </div>
          </div>
        </React.Fragment>
      ) : !loading && successMessage ? <div id="successMessageContainer">
      <h3>Please check your inbox to verify your email.</h3>
      <br/><br/>
      <h4>You may now close this tab.</h4>
     
    </div> : null }
    </React.Fragment>
  );
};
export default NewUser;
// < EmailConflictAlert />
